import { SUPER_ADMIN_SEAT_FEATURES_FETCH_SUCCESS } from '../types';

/**
 * Per-seat feature overrides, keyed by `${costCenterId}:${productAccessId}`.
 *
 * Each value is the raw row list from ADMIN_GET_FEATURES_FOR_PRODUCT_ACCESS: seat overrides
 * only. The product-access level value is NOT here - that lives on the cost centre the caller
 * already fetched, and resolving the two is the consumer's job.
 */
export interface SeatFeatureRow {
  id: string;
  product_feature_id: string;
  user_id: string;
  feature_name: string;
  value_type: string;
  value: string;
  enabled: boolean;
}

type SeatFeaturesState = Record<string, SeatFeatureRow[]>;

interface SeatFeaturesAction {
  type?: string;
  costCenterId?: string;
  productAccessId?: string;
  features?: unknown;
}

export const seatFeaturesKey = (costCenterId: string, productAccessId: string): string =>
  `${costCenterId}:${productAccessId}`;

const initialState: SeatFeaturesState = {};

const seatFeatures = (
  state: SeatFeaturesState = initialState,
  action: SeatFeaturesAction = {},
): SeatFeaturesState => {
  switch (action.type) {
    case SUPER_ADMIN_SEAT_FEATURES_FETCH_SUCCESS:
      return {
        ...state,
        [seatFeaturesKey(action.costCenterId as string, action.productAccessId as string)]:
          (action.features as SeatFeatureRow[]) || [],
      };
    default:
      return state;
  }
};

export default seatFeatures;
